export const supplierSupplementViewModelStructure = {
    Amount: true,
    IdCurrency: true,
    Currency: {
        Name: true,
    },
    Description: true,
    EffectivePerson: true,
    Enabled: true,
    FromDate: true,
    FromAge: true,
    ToAge: true,
    Id: true,
    Name: true,
    OnlyAdults: true,
    OnlyChildren: true,
    Priority: true,
    ToDate: true,
    IdSupplierHotel: true,
    SupplierHotel: {
        Name: true,
    },
    IdSupplementCalculationType: true,
    SupplementCalculationType: {
        Name: true,
        LocalizedCaption: true,
        Caption: true,
        Key: true,
    },
    IdSupplierHotelMealPlan: true,
    SupplierHotelMealPlan: {
        Name: true,
    },
    IdSupplierHotelRatePlan: true,
    SupplierHotelRatePlan: {
        Name: true,
    },
    IdSupplierHotelRoomType: true,
    SupplierHotelRoomType: {
        Name: true,
    },
    IdSupplierTaxCalculationRuleType: true,
    SupplierTaxCalculationRuleType: {
        Caption: true,
        LocalizedCaption: true,
        Name: true,
        Key: true,
    },
    IdSupplierTaxCalculationType: true,
    SupplierTaxCalculationType: {
        Caption: true,
        LocalizedCaption: true,
        Name: true,
        Key: true,
    },
};
